import { PLAN_ALLOWED_CHANNELS } from './constants'

/**
 * Can add new brand
 * @param {object} plan
 * @param {object} plan.limits
 * @param {number} plan.limits.brands
 * @param {number} [count] current total brands
 *
 * @returns {boolean}
 */
export const canAddBrand = (plan = {}, count) => {
  const { limits } = plan

  try {
    if (!limits) return false
    const { brands } = limits

    if (typeof brands !== 'number') return false
    if (brands === 0) return false

    if (brands === -1) return true
    if (count && count >= brands) return false

    return true
  } catch(error) {
    return false
  }
}

/**
 * Can add new delegation
 * @param {object} plan
 * @param {object} plan.limits
 * @param {number} plan.limits.brands
 * @param {number} [count] current total delegations
 *
 * @returns {boolean}
 */
export const canAddDelegation = (plan = {}, count) => {
  const { limits } = plan

  try {
    if (!limits) return false
    const { delegations } = limits

    if (typeof delegations !== 'number') return false
    if (delegations === 0) return false

    if (delegations === -1) return true
    if (count && count >= delegations) return false

    return true
  } catch(error) {
    return false
  }
}

/**
 * Check if there are any modules that are not free
 * @param {object} plan
 * @param {object} plan.includedFreePrice
 *
 * @returns {boolean}
 */
export const hasModuleNotFree = (plan = {}) => {
  const { includedFreePrice, version } = plan

  try {
    if (version !== 'v1') return false
    if (!includedFreePrice) return false

    const {
      faqConsole, smartChat, pluginEcommerce,
      crmMarketing, metricsBasic, smartChatEcommerce
    } = includedFreePrice

    if (!faqConsole) return true
    if (!crmMarketing) return true
    if (!metricsBasic) return true
    if (!smartChat) return true
    if (!pluginEcommerce) return true
    if (!smartChatEcommerce) return true

    return false
  } catch(error) {
    return false
  }
}

/**
 * Can add new channel
 * @param {object} plan
 * @param {object} plan.companyPlan
 * @param {number} plan.version
 * @param {string} [channelName] channel to validate
 *
 * @returns {boolean}
 */
export const canAddChannel = (plan = {}, channelName) => {
  const { companyPlan, version, limits } = plan

  try {
    if (version === 'v1') return true

    if (!channelName) return false
    if (typeof channelName !== 'string') return false
    if (!companyPlan) return false

    if (!limits?.androidApp && channelName === 'android') return false
    if (!limits?.iosApp && channelName === 'ios') return false

    const allowedChannels = PLAN_ALLOWED_CHANNELS[companyPlan.toLowerCase()]
    if (!allowedChannels?.length) return true

    return allowedChannels.includes(channelName)
  } catch(error) {
    return false
  }
}

/**
 * Check if a role is available in current plan
 * @param {object} plan
 * @param {object} plan.limits
 * @param {string} [role] role to validate
 *
 * @returns {boolean}
 */
export const isAvailableRole = (plan = {}, role) => {
  try {
    const { limits = {} } = plan

    let key = role
    if (typeof limits?.operators === 'number' && limits?.operators !== 0) {
      key = 'operators'
    }

    const limit = limits[key]
    if (typeof limit !== 'number') return false
    if (limit === 0) return false

    return true
  } catch (error) {
    return false
  }

}
